
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumConentError } from '@xt/client/entities/course-v2/user-content'

@Observer
@Component({
  components: {}
})
export default class ErrorRight extends Vue {
  @Prop({ required: true }) type: EnumConentError

  get EnumConentError() {
    return EnumConentError
  }
}
